import {format, parseISO} from 'date-fns';

import Typography from 'components/Typography';

import {File, Order, Transaction} from 'types';

import styles from './Note.module.scss';
import Avatar from 'components/Avatar';
import {useHistory} from 'react-router-dom';
import {getCardTypeLabel} from 'helpers/getCardTypeIcon';
import {Fragment} from 'react/jsx-runtime';
import {useCallback} from 'react';

interface Props {
  text: string;
  created_at: string;
  author: string;
  avatar?: File;
  route_id?: number | null;
  order_id?: number | null;
  isCompleted: boolean;
  is_visible_to_prescribers: boolean;
  is_visible_to_drivers: boolean;
  isRouteClickable?: boolean;
  transactions?: Transaction[];
}
// const dummyTransactions: Transaction[] = [
//   {
//     transaction_id: '630130209',
//     amount: '110.00',
//     service_name: 'CreditSale',
//     status: 'A',
//     transaction_date: '2025-12-19T17:42:59.557000-05:00',
//     transaction_origin: 'dashboard',
//     list_rx: [
//       {
//         id: 212312,
//         rx_no: '175129',
//         status: 'filled' as OrderStatus,
//         attempt: 1,
//         is_paid: true,
//         customer: 'Tiffany EDWARDS',
//         rx2go_id: null,
//         bill_date: '12/19/25 Fri',
//         bill_time: '04:17 PM',
//         drug_name: 'OSELTAMIVIR PHOSPHAT 75MG CAP',
//         last_paid: 10,
//         refill_no: '0/0',
//         sync_date: '12/18/25 Thu',
//         sync_time: '09:21 AM',
//         amount_due: 10,
//         created_at: '2025-12-18T00:00:00-05:00',
//         doctor_name: 'Alexandra Rooker',
//         doctor_phone: '6462005750',
//         request_note: null,
//         request_origin: 'micromerchant',
//         meta_event_type: 'Lead',
//         preference_date: '',
//         preference_time: '',
//         prescription_id: 211807,
//         have_prescription: null,
//         is_urgent_delivery: false,
//       },
//       {
//         id: 212138,
//         rx_no: '175052',
//         status: 'filled' as OrderStatus,
//         attempt: 1,
//         is_paid: true,
//         customer: 'Tiffany EDWARDS',
//         rx2go_id: null,
//         bill_date: '12/17/25 Wed',
//         bill_time: '04:52 PM',
//         drug_name: 'MOUNJARO 10MG/0.5ML INJ',
//         last_paid: 100,
//         refill_no: '0/0',
//         sync_date: '12/17/25 Wed',
//         sync_time: '04:38 PM',
//         amount_due: 100,
//         created_at: '2025-12-17T00:00:00-05:00',
//         doctor_name: 'Alexandra Rooker',
//         doctor_phone: '6462005750',
//         request_note: null,
//         request_origin: 'micromerchant',
//         meta_event_type: 'Lead',
//         preference_date: '',
//         preference_time: '',
//         prescription_id: 211633,
//         have_prescription: null,
//         is_urgent_delivery: false,
//       },
//     ],
//     customer: {
//       id: 10705,
//       user: {
//         id: 105658,
//         role: 'customer',
//         email: 'tiffywiffy530@gmail.com',
//         phone: '(631) 521-0415',
//         last_name: 'EDWARDS',
//         first_name: 'Tiffany',
//       },
//       birthday: '1982-12-10',
//       allergies: null,
//       patient_no: 8370,
//     },
//     auth_code: null,
//     authorizated_amount: '110.00',
//     authorized_amount: null,
//     client_transaction_id: null,
//     convenience_amount: null,
//     device_id: '3876713',
//     gateway_response_code: '00',
//     gateway_response_message: null,
//     issuer_response_code: '00',
//     issuer_response_message: 'APPROVAL',
//     masked_card_number: '2005',
//     card_type: 'amex',
//     original_transaction_id: '0',
//     reference_number: null,
//     settlement_amount: '110.00',
//     shipping_amount: null,
//     is_refunded: false,
//   },
// ];

//"Patient Dana WU has been charged $650.00 for RX1, (RX2, RX3, RX4). Card last 4: #1234. Card Type: Visa. Transaction ID: XYZ"
function Note({
  text,
  author,
  avatar,
  created_at,
  route_id,
  order_id,
  isCompleted,
  is_visible_to_prescribers,
  is_visible_to_drivers,
  isRouteClickable,
  transactions,
}: Props) {
  const history = useHistory();

  const payment_url = 'medsrx.com/payment?';

  const transaction_id = text.includes('Transaction ID')
    ? text.split('Transaction ID: ')[1]
    : null;

  const transaction = transactions?.find(
    (t) => t.transaction_id === transaction_id
  );

  const lasttext = text.includes('Transaction ID')
    ? text.slice(0, text.lastIndexOf('Transaction ID: '))
    : text.includes(payment_url)
    ? text.slice(0, text.indexOf('payment:') + 9)
    : text;

  const handleRouteClick = () => {
    if (!route_id) return;
    history.push(`/history/routes/${route_id}`);
  };

  const renderRxList = useCallback(
    (rxList?: Order[]) => {
      if (!rxList || rxList.length === 0) return null;

      return (
        <Fragment>
          <span className={styles.text}>&nbsp;RXs: &nbsp;</span>
          {rxList?.map((rx, index) => (
            <Fragment key={rx.id}>
              <span
                onClick={() => history.push(`/orders/${rx.id}`)}
                className={styles.transaction_id}
              >
                {rx.rx_no}
              </span>
              <span className={styles.text}>
                {index < rxList.length - 1 ? ',' : '.'} &nbsp;
              </span>
            </Fragment>
          ))}
        </Fragment>
      );
    },
    [history]
  );

  const renderCardInfo = useCallback((transaction?: Transaction) => {
    if (!transaction) return null;
    const cardType = transaction?.card_type;
    const cardLast4 = transaction?.masked_card_number;
    return (
      <Fragment>
        <span className={styles.text}>
          &nbsp;Card last 4: {cardLast4}. &nbsp;
        </span>

        {!!cardType && (
          <>
            <span className={styles.text}>
              Card Type: {getCardTypeLabel(cardType)}. &nbsp;
            </span>
          </>
        )}
      </Fragment>
    );
  }, []);
  return (
    <div className={styles.root}>
      {is_visible_to_prescribers && (
        <p className={styles.visible}>Visible to prescriber</p>
      )}
      {is_visible_to_drivers && (
        <p className={styles.visible}>Visible to driver</p>
      )}
      <div className={styles.row_name}>
        <Typography variant="p">
          {lasttext}
          {text.includes(payment_url) && (
            <a
              rel="noreferrer"
              href={`${text.split('payment:')[1]}`}
              target="_blank"
            >
              {text.split('payment: ')[1]}
            </a>
          )}
        </Typography>
        {text.includes('Transaction ID') && (
          <>
            {renderRxList(transaction?.list_rx as Order[])}
            {renderCardInfo(transaction)}
            <span className={styles.text}>Transaction ID:&nbsp;</span>
            <Typography
              onClick={() =>
                history.push(`/transactions/${transaction_id}`, {
                  isRouteHistory: true,
                })
              }
              className={styles.transaction_id}
              variant="p"
            >
              {transaction_id}
            </Typography>
          </>
        )}

        {isCompleted && (
          // <NavLink to={`/deliveries/delivery_planner?id=${route_id}`}>
          <>
            <Typography
              onClick={() => {
                history.push(`/history/routes/${route_id}`, {
                  isRouteHistory: true,
                });
              }}
              className={styles.route_id}
              variant="p"
            >
              See route
            </Typography>
            <Typography
              onClick={() => {
                history.push(`/history/routes/${route_id}`, {
                  showPdf: true,
                  order_id,
                });
              }}
              className={styles.route_id}
              variant="p"
            >
              See Delivery PDF
            </Typography>
          </>
          // </NavLink>
        )}
        {!isCompleted && isRouteClickable && !!route_id && (
          <Typography
            onClick={handleRouteClick}
            className={styles.route_id}
            variant="p"
          >
            See route
          </Typography>
        )}
      </div>
      <div className={styles.bottom}>
        <div className={styles.author}>
          <Avatar name={author} file={avatar} size="sm" />
          <span className={styles.author__name}>{author}</span>
        </div>
        <span className={styles.datetime}>
          {format(parseISO(created_at), 'MMMM d Y, h:mm aa')}
        </span>
      </div>
    </div>
  );
}

export default Note;
